"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressFieldEditor = exports.AddressData = void 0;
const contextMenuControl_1 = require("./contextMenuControl");
const query_1 = require("./query");
class AddressData {
    constructor() {
        this.Latitude = '0';
        this.Longitude = '0';
        this.IncludeInstructions = true;
        this.IncludeAttention = true;
    }
}
exports.AddressData = AddressData;
class AddressFieldEditor {
    get value() {
        let value = new AddressData();
        value.Address = this.addressInput.value || '';
        value.Suburb = this.suburbInput.value || '';
        value.Phone = this.phoneInput.value || '';
        value.PostCode = this.postcodeInput.value || '';
        value.Instructions = this.instInput.value || '';
        value.State = this.stateSelect.value || '';
        value.Latitude = '0';
        value.Longitude = '0';
        value.Attention = this.attnInput.value || '';
        value.IncludeAttention = this.container.classList.contains('inc-attn');
        value.IncludeInstructions = this.container.classList.contains('inc-inst');
        return value;
    }
    set value(value) {
        this.addressInput.value = value ? value.Address || '' : '';
        this.suburbInput.value = value ? value.Suburb || '' : '';
        this.phoneInput.value = value ? value.Phone || '' : '';
        this.postcodeInput.value = value ? value.PostCode || '' : '';
        this.instInput.value = value ? value.Instructions || '' : '';
        this.stateSelect.value = value ? value.State || '' : '';
        this.attnInput.value = value ? value.Attention || '' : '';
        if (value) {
            if (value.IncludeAttention)
                this.container.classList.add('inc-attn');
            else
                this.container.classList.remove('inc-attn');
            if (value.IncludeInstructions)
                this.container.classList.add('inc-inst');
            else
                this.container.classList.remove('inc-inst');
        }
        this.updateInputFromFields();
    }
    updateInputFromFields() {
        this.input.value = JSON.stringify(this.value);
        //this.input.dispatchEvent(new Event('change'));
    }
    constructor(container) {
        this.container = container;
        let me = this;
        query_1.Z.forEachFrom(container, '.context-menu', el => {
            this.contextMenu = new contextMenuControl_1.ContextMenu(el, {
                actions: {
                    clear(ev) {
                        me.value = new AddressData();
                    },
                    copyAddress(ev) {
                        AddressFieldEditor.copiedAddress = JSON.parse(JSON.stringify(me.value));
                    },
                    pasteAddress(ev) {
                        if (AddressFieldEditor.copiedAddress) {
                            let addr = JSON.parse(JSON.stringify(AddressFieldEditor.copiedAddress));
                            if (me.value !== undefined && addr) {
                                addr.IncludeAttention = me.value.IncludeAttention;
                                addr.IncludeInstructions = me.value.IncludeInstructions;
                            }
                            me.value = addr;
                        }
                    },
                    toggleAttention(ev) {
                        me.container.classList.toggle('inc-attn');
                    },
                    toggleInstructions(ev) {
                        me.container.classList.toggle('inc-inst');
                    },
                }
            });
        });
        query_1.Z.forEachFrom(container, `[data-sub-field="value"]`, el => {
            //el.addEventListener('change', ev => this.updateInputFromFields());
            //el.addEventListener('input', ev => this.updateInputFromFields());
            this.input = el;
            this.input.addEventListener('change', ev => {
                let jobj = JSON.parse(this.input.value);
                let addr = new AddressData();
                let props = [
                    'Address', 'Attention', 'IncludeAttention', 'IncludeInstructions', 'Instructions',
                    'Latitude', 'Longitude', 'Phone', 'PostCode', 'State', 'Suburb'
                ];
                props.forEach(k1 => {
                    Object.keys(jobj).forEach(k2 => {
                        if (`${k1}`.toLowerCase().trim() == `${k2}`.toLowerCase().trim()) {
                            addr[k1] = jobj[k2];
                        }
                    });
                });
                this.value = addr;
            });
        });
        query_1.Z.forEachFrom(container, `[data-sub-field="address"]`, el => {
            el.addEventListener('change', ev => this.updateInputFromFields());
            el.addEventListener('input', ev => this.updateInputFromFields());
            this.addressInput = el;
        });
        query_1.Z.forEachFrom(container, `[data-sub-field="suburb"]`, el => {
            el.addEventListener('change', ev => this.updateInputFromFields());
            el.addEventListener('input', ev => this.updateInputFromFields());
            this.suburbInput = el;
        });
        query_1.Z.forEachFrom(container, `[data-sub-field="postcode"]`, el => {
            el.addEventListener('change', ev => this.updateInputFromFields());
            el.addEventListener('input', ev => {
                let stripped = '';
                for (let i = 0; i < el.value.length; i++) {
                    if (el.value[i] >= '0' && el.value[i] <= '9')
                        stripped += el.value[i];
                }
                if (stripped != el.value)
                    el.value = stripped;
                this.updateInputFromFields();
            });
            this.postcodeInput = el;
        });
        query_1.Z.forEachFrom(container, `[data-sub-field="state"]`, el => {
            el.addEventListener('change', ev => this.updateInputFromFields());
            this.stateSelect = el;
        });
        query_1.Z.forEachFrom(container, `[data-sub-field="attn"]`, el => {
            el.addEventListener('change', ev => this.updateInputFromFields());
            el.addEventListener('input', ev => this.updateInputFromFields());
            this.attnInput = el;
        });
        query_1.Z.forEachFrom(container, `[data-sub-field="phone"]`, el => {
            el.addEventListener('change', ev => this.updateInputFromFields());
            el.addEventListener('input', ev => {
                this.updateInputFromFields();
            });
            this.phoneInput = el;
        });
        query_1.Z.forEachFrom(container, `[data-sub-field="inst"]`, el => {
            el.addEventListener('change', ev => this.updateInputFromFields());
            el.addEventListener('input', ev => this.updateInputFromFields());
            this.instInput = el;
        });
    }
    static init() {
        query_1.Z.init('.address-field-editor', 'address-editor', el => {
            return new AddressFieldEditor(el);
        });
    }
}
exports.AddressFieldEditor = AddressFieldEditor;
AddressFieldEditor.copiedAddress = null;
//# sourceMappingURL=addressFieldEditor.js.map